import dayjs from 'dayjs';

const formatPostTime = (dateline: number, isMobile = false): string => {
  const date = dayjs.unix(dateline);
  const now = dayjs();
  const diffMinutes = now.diff(date, 'minute');
  const diffHours = now.diff(date, 'hour');

  if (diffMinutes < 60) {
    return `${diffMinutes}分钟前`;
  }

  if (diffHours < 24) {
    return `${diffHours}小时前`;
  }

  if (date.year() === now.year()) {
    if (isMobile) {
      return date.format('M月D日');
    }
    return date.format('M月D日 HH:mm');
  }

  if (isMobile) {
    return date.format('YYYY年M月D日');
  }
  return date.format('YYYY年M月D日 HH:mm');
};

export default formatPostTime;
